import * as x from '../helpers/xmlHelpers';
import * as h from '../helpers/helpers';

export class Address {
    constructor(doc)
    {
		this.label = null
		this.addressLineText = null
		this.addressUnitDesignatorType = null
		this.addressUnitIdentifier = null
		this.cityName = null
		this.countyName = null
		this.postalCode = null
		this.stateCode = null

		this.label = x.getStringAttribute(doc,"xlink:label");
		this.addressLineText = x.getStringElement(doc, "./ns:AddressLineText");
		this.addressUnitDesignatorType = x.getStringElement(doc, "./ns:AddressUnitDesignatorType");
		this.addressUnitIdentifier = x.getStringElement(doc, "./ns:AddressUnitIdentifier");
		this.cityName = x.getStringElement(doc, "./ns:CityName");
		this.countyName = x.getStringElement(doc, "./ns:CountyName");
		this.postalCode = x.getStringElement(doc, "./ns:PostalCode");
		this.stateCode = x.getStringElement(doc, "./ns:StateCode");
   }

    GetCSZ() {
    	return this.cityName + ", " + this.stateCode + " " + this.postalCode;
    }

    GetFullStreetAddress() {
        let street = this.addressLineText;
        if (this.addressUnitDesignatorType && this.addressUnitDesignatorType.trim() !== '') {
            street += ',' + this.addressUnitDesignatorType + ' ' + this.addressUnitIdentifier;
        }
        return street;
    }

    GetStreetAddress() {
        return this.addressLineText;
    }

    GetUnitIdentifierAddress() {
        if (this.addressUnitDesignatorType && this.addressUnitDesignatorType.trim() !== '') {
            return  this.addressUnitDesignatorType + ' ' + this.addressUnitIdentifier;
        }
        return "";
    }

    GetFullAddress() {
        let adr = this.GetStreetAddress();
        adr = h.addWithNewline(adr, this.GetUnitIdentifierAddress());
        adr = h.addWithNewline(adr, this.GetCSZ());
        return adr;
    }
    
    GetFullAddressList() {
        var adr = [];
        adr.push(this.GetFullStreetAddress());
        adr.push(this.GetCSZ());
        return adr;
    }

    GetFullAddressNarrow() {
        let adr = this.SplitLotBlock(this.addressLineText);
        if (this.addressUnitDesignatorType && this.addressUnitDesignatorType.trim() !== '') {
            adr += '\n' + this.addressUnitDesignatorType + ' ' + this.addressUnitIdentifier;
        }
        adr += '\n';
        adr += this.GetCSZ();
        return adr;
    }

    SplitLotBlock(adr) {
        // this assumes a format of 'Lot: xx Block: yy street'
        let newAdr = adr;
        const ix = adr.indexOf('Block: ');
        if (ix >= 0) {
            const iy = adr.indexOf(' ', ix + 7);
            newAdr = adr.substring(0, iy);
            newAdr += '\n';
            newAdr += adr.substring(iy + 1);
        }
        return newAdr;
    }
}
